import React, { useMemo } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Table from "../../../components/Table/Table";
import { Header } from "../../../components";
import { ApproverApprovedAndRejectedBaseColumns } from "../../../utils/utils";
import TicketButton from "../../../components/TableComponents/TicketButton/TicketButton";
import TableLayout from "../../../layouts/TableLayout/TableLayout";
import useTicketData from "../../../hooks/useTicketData";
import DocumentViewerModal from "../../../components/DocumentViewerModal/DocumentViewerModal";
import useDocumentViewer from "../../../hooks/useDocumentViewer";
import useTicketExport from "../../../hooks/useTicketExport";
import PhysicalDocumentToggle from "../../../components/TableComponents/PhysicalDocumentToggle/PhysicalDocumentToggle";
import NoItemsFound from "../../../components/NoItemsFound/NoItemsFound";

// import fetch

function Approved() {
  const {
    searchQuery,
    allRows: filteredRows,
    loading,
    isRefreshing,
    handleRefresh,
    handleSearchQuery,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTicketData("APPROVER_APPROVED", true);

  const {
    documentViewerModal,
    handleDownloadFile,
    handleViewDocument,
    handleCloseDocumentViewer,
  } = useDocumentViewer();

  const columns = useMemo(() => {
    const updatedColumns = [...ApproverApprovedAndRejectedBaseColumns];

    updatedColumns[0] = {
      width: 180,
      title: "Ticket Number",
      field: "ticketNumber",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <TicketButton
          ticketNumber={rowData.ticketNumber}
          ticketId={rowData.id}
        />
      ),
    };

    updatedColumns[3] = {
      width: 260,
      title: "Physical Document Received",
      field: "physicalDocumentReceived",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => {
        const value = rowData.physicalDocumentReceived;

        return <PhysicalDocumentToggle checked={value} />;
      },
    };

    updatedColumns[4] = {
      width: 220,
      title: "Document",
      field: "document",
      enableSearch: false,
      enableFilter: false,
      render: (rowData) => (
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span>{rowData.entitlementLetter}</span>
          <Tooltip title="Downloaded">
            <IconButton
              size="small"
              color="primary"
              onClick={() => {
                handleDownloadFile(rowData.ticketNumber);
              }}
            >
              <GetAppIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="View">
            <IconButton
              size="small"
              color="primary"
              onClick={() => handleViewDocument(rowData.ticketNumber)}
            >
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    };

    return updatedColumns;
  }, [handleDownloadFile, handleViewDocument]);

  const { handleExport, isExporting } = useTicketExport(
    "APPROVER_APPROVED",
    columns
  );

  return (
    <TableLayout
      styles={{ tableInnerWrapper: { paddingBottom: "0rem" } }}
      header={
        <Header
          searchQuery={searchQuery}
          handleSearchQuery={handleSearchQuery}
          onRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          onExport={handleExport}
          isExporting={isExporting}
          disableExport={filteredRows.length === 0}
        />
      }
    >
      {filteredRows.length === 0 ? (
        <NoItemsFound />
      ) : (
        <Table
          columns={columns}
          defaultColumns={columns}
          rows={filteredRows}
          hideCheckbox
          rowHeight={45}
          setHasActiveEdits={() => {}}
          isDataLoading={loading || isRefreshing}
          serverSide
          totalRows={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      <DocumentViewerModal
        open={documentViewerModal.open}
        onClose={handleCloseDocumentViewer}
        documentUrl={documentViewerModal.documentUrl}
        documentName={documentViewerModal.documentName}
        documentType={documentViewerModal.documentType}
        isLoading={documentViewerModal.isLoading}
        error={documentViewerModal.error}
      />
    </TableLayout>
  );
}

export default Approved;
